const CATEGORIES = [
  { id: "appetizers", label: "Appetizers" },
  { id: "salads-and-dressings", label: "Salads & Dressings" }, 
];

const find = (options, value, id = "id", label = "label") => {
  const foundItem = options.find(option => option[id] === value);

  if (!foundItem) {
    return null;
  }

  return foundItem[label];
};

export default {
  find,
  CATEGORIES,
};
